import { Component, ChangeDetectionStrategy, input, output, viewChild } from '@angular/core';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { UILanguageDto } from '@core/services/api-clients';

@Component({
    selector: 'app-language-picker',
    templateUrl: './language-picker.component.html',
    styleUrls: ['./language-picker.component.scss'],
    exportAs: 'languageMenu',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatMenu,
        MatMenuItem,
        ]
})
export class LanguagePickerComponent {
  readonly menu = viewChild(MatMenu);
  readonly languages = input<UILanguageDto[]>(undefined);
  readonly selectedLanguage = input<UILanguageDto>(undefined);

  readonly languageSelected = output<UILanguageDto>();

  selectLanguage(language) {
    this.languageSelected.emit(language);
  }
}
